import React from 'react'
import { bool, string } from 'prop-types'
import styled, { css } from 'styled-components'

import * as spacing from 'styles/spacing'
import { white, black } from 'styles/colors'
import Spinner from 'components/Spinner'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${white};
  z-index: 450;

  ${props =>
    props.asDiv &&
    css`
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${white};
      padding: ${spacing.large} 0;
      z-index: 400;
    `}
`

const Label = styled.p`
  margin-top: ${spacing.medium};
  color: ${black};
`

const Loading = ({ asDiv, label }) => (
  <Container asDiv={asDiv}>
    <Spinner isLarge />
    {label && <Label>{label}</Label>}
  </Container>
)

Loading.propTypes = {
  asDiv: bool,
  label: string
}

export default Loading
